"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    domainIDPlugin: ()=>domainIDPlugin
});
const index_js_namespaceObject = require("../../domain-id/index.js");
const external_tool_js_namespaceObject = require("../../tool.js");
function domainIDPlugin(domainIDPluginConfig) {
    return {
        request: [
            async (config)=>{
                var _config_pluginConfig, _config_pluginConfig1;
                const { domainIDRequestOption, domainID, module } = domainIDPluginConfig;
                var _config_url;
                const url = null != (_config_url = config.url) ? _config_url : '';
                if (/^https?:/.test(url)) return config;
                const option = await Promise.resolve(domainIDRequestOption);
                var _config_pluginConfig_domainID, _ref;
                const innerDomainID = null != (_ref = null != (_config_pluginConfig_domainID = null == (_config_pluginConfig = config.pluginConfig) ? void 0 : _config_pluginConfig.domainID) ? _config_pluginConfig_domainID : domainID) ? _ref : (0, external_tool_js_namespaceObject.tryCatch)(index_js_namespaceObject.getCurrentDomainID, (error)=>{
                    console.error({
                        message: null == error ? void 0 : error.message,
                        position: 'domainIDPlugin',
                        context: {
                            domainIDPluginConfig,
                            globalPluginConfig: config.pluginConfig,
                            currentDomainID: index_js_namespaceObject.currentDomainID
                        }
                    });
                    throw error;
                });
                const moduleConfig = option[innerDomainID];
                if (!moduleConfig) throw new external_tool_js_namespaceObject.CommonLibError('DomainIDPlugin', `please set ${innerDomainID} environment url in domainID plugin`);
                var _config_pluginConfig_module;
                const usedModule = null != (_config_pluginConfig_module = null == (_config_pluginConfig1 = config.pluginConfig) ? void 0 : _config_pluginConfig1.module) ? _config_pluginConfig_module : module;
                if (!usedModule) throw new external_tool_js_namespaceObject.CommonLibError('DomainIDPlugin', `please set module ${usedModule} in domainID plugin`);
                const prefixUrl = null == moduleConfig ? void 0 : moduleConfig[usedModule];
                if (!prefixUrl) throw new external_tool_js_namespaceObject.CommonLibError('DomainIDPlugin', `domainID ${innerDomainID} module ${usedModule} cannot find prefix url`);
                config.url = `${prefixUrl}${url}`;
                return config;
            }
        ]
    };
}
exports.domainIDPlugin = __webpack_exports__.domainIDPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "domainIDPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
